import React, { useContext, useEffect, useState } from "react";
import { Stack, Divider, SvgIcon, Link } from "@mui/material";
import SideNavFooterItem from "./side-nav-footer-item";
import Settings01 from "@untitled-ui/icons-react/build/esm/Settings01";
import LogOut01Icon from "@untitled-ui/icons-react/build/esm/LogOut01";
import Headphones02Icon from "@untitled-ui/icons-react/build/esm/Headphones02";
import { useCallback } from "react";
import toast from "react-hot-toast";

import { useAuth } from "src/hooks/use-auth";
import { usePathname } from "src/hooks/use-pathname";
import { useRouter } from "src/hooks/use-router";
import { paths } from "src/paths";
import { Issuer } from "src/utils/auth";
import { getSessionStorage } from "src/utils/storage";
import { AccountButton } from "../account-button";
import { useTranslation } from "react-i18next";
import { SideNavSection } from "../vertical-layout/side-nav-section";
import { WhiteLabelConfigurationContext } from "src/contexts/ClientConfiguration";
import {
  ArrowCircleUpOutlined,
  LibraryAddCheckOutlined,
} from "@mui/icons-material";
import SideNavItemNew from "../vertical-layout/side-nav-item-new";
import ExportNotifications from "src/components/ExportNotifications";

const SideNavFooter = ({ open, expand, setExpand }) => {
  const getDomainFromLocation = () => {
    const domain = window.location.hostname;
    return domain;
  };
  const { subUserStatus, whiteLableStatus, supportCenterURL, getUserInfo } =
    useContext(WhiteLabelConfigurationContext);
  const domain = getDomainFromLocation();
  const router = useRouter();
  const auth = useAuth();
  const user = {
    name: getSessionStorage("fullName"),
    email: getSessionStorage("userEmail"),
  };
  const pathname = usePathname();

  useEffect(() => {
    getUserInfo();
  }, []);
  const handleLogout = useCallback(async () => {
    try {
      switch (auth.issuer) {
        case Issuer.Amplify: {
          await auth.signOut();
          break;
        }

        case Issuer.Auth0: {
          await auth.logout();
          break;
        }

        case Issuer.Firebase: {
          await auth.signOut();
          break;
        }

        case Issuer.JWT: {
          await auth.signOut();
          break;
        }

        default: {
          console.warn("Using an unknown Auth Issuer, did not log out");
        }
      }

      router.push(paths.index);
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong!");
    }
  }, [auth, router]);
  //console.log(
  //   subUserStatus && supportCenterURL
  //     ? supportCenterURL
  //     : paths.dashboard.supportCenter,
  //   subUserStatus,
  //   supportCenterURL,
  //   "Sdfsdfsdfsdf"
  // );
  function handleAuxClick(event) {
    if (event.button === 1) {
      event.preventDefault(); // Prevent the default behavior of opening links in new tabs
    }
    if (event.metaKey) {
      event.preventDefault(); // Prevent the default behavior if Command key is pressed
    }
  }
  const { t } = useTranslation();
  const footerSections = [
    // {
    //   title: t("Settings"),
    //   path: paths.dashboard.account,
    //   icon: (
    //     <SvgIcon fontSize="medium">
    //         <Settings01 />
    //     </SvgIcon>
    //   ),
    // },
    ...((window.location.hostname !== "qa.b2brocket.ai" || window.location.hostname !== "app.b2brocket.ai") &&
      whiteLableStatus &&
      !supportCenterURL
      ? []
      : [
        {
          title: t("Support"),
          path:
            (subUserStatus || whiteLableStatus) && supportCenterURL
              ? supportCenterURL.startsWith("http")
                ? supportCenterURL
                : `https://${supportCenterURL}`
              : paths.dashboard.supportCenter,
          external: !!(subUserStatus && supportCenterURL), // Simplified boolean condition
          icon: (
            <SvgIcon fontSize="medium">
              <Headphones02Icon />
            </SvgIcon>
          ),
        },
      ]),
    // {
    //   title: t("Upgrade"),
    //   path: paths.dashboard.upgrade,
    //   icon: (
    //     <SvgIcon fontSize="medium">
    //       <ArrowCircleUpOutlined />
    //     </SvgIcon>
    //   ),
    // },
    // {
    //   title: t("Onboarding Hub"),
    //   path: paths.dashboard.onboardingHub,
    //   icon: (
    //     <SvgIcon fontSize="medium">
    //       <LibraryAddCheckOutlined />
    //     </SvgIcon>
    //   ),
    // },
  ];
  return (
    <Stack rowGap={2}>
      {/* <Stack
        component="ul"
        spacing={0.5}
        sx={{
          listStyle: "none",
          m: 0,
          p: 0,
          gap: "10px",
          alignDelf: "stretch",
          //borderTop: "0.2px inset",
          color: "#F2F4F7",
          fontFamily: "DM Sans",
        }}
      >
        <SideNavFooterItem
          active={paths.dashboard.account === pathname}
          depth={0}
          disabled={false}
          icon={<Settings01 />}
          key={"Settings"}
          label={""}
          open={true}
          path={paths.dashboard.account}
          handleClick={(e) => {handleAuxClick(e)}}
          title={"Settings"}
        />
        <SideNavFooterItem
          active={paths.dashboard.supportCenter === pathname}
          depth={0}
          disabled={false}
          icon={<Headphones02Icon />}
          key={"Support Center"}
          label={""}
          open={true}
          path={paths.dashboard.supportCenter}
          handleClick={(e) => {handleAuxClick(e)}}
          title={"Support Center"}
        />
        <SideNavFooterItem
          active={false}
          depth={0}
          disabled={false}
          icon={<LogOut01Icon />}
          key={"Logout"}
          label={""}
          open={true}
          handleClick={handleLogout}
          title={"Log out"}
        /> 
      </Stack> */}
      
      <Stack
        component="nav"
        sx={{
          flexGrow: 1,
          px: "12px",
        }}
      >
        {/* <ExportNotifications expanded={open} /> */}
        {/*
         ((subUserStatus && supportCenterURL) || whiteLableStatus) &&
          footerSections?.map((section, index) => (
            <SideNavSection
              open={open}
              sx={{
                padding: "0px 4px",
                gap: "10px",
                margin: 0,
                listStyleType: "none",
                fontFamily: "DM Sans",
              }}
              key={index}
              pathname={pathname}
              title={section.title}
              path={section.path}
              icon={section.icon}
              external={section.external}
              subheader={section.subheader}
              items={section.items}
              expand={expand}
              setExpand={setExpand}
              cssVariables={{}}
            />
          ))} */}
        {((subUserStatus && supportCenterURL) || whiteLableStatus) &&
          footerSections?.map((navItem, index) => {
            const childPaths = navItem.childPaths;
            const isActive = childPaths
              ? childPaths?.length > 0
                ? childPaths
                    ?.concat(navItem.path)
                    ?.some((path) => pathname === path)
                : pathname === navItem.path
              : pathname === navItem.path;
            return (
              <SideNavItemNew
                active={isActive}
                disabled={navItem.disabled}
                external={navItem.external}
                icon={navItem.icon}
                path={navItem.path}
                title={navItem.title}
                options={navItem.options || []}
                index={index}
                expanded={open}
              />
            );
          })}
      </Stack>
      <Stack
        alignItems="center"
        direction="row"
        spacing={2}
        sx={{ px: "12px" }}
      >

        <AccountButton expanded={open} />
      </Stack>
    </Stack>
  );
};

export default SideNavFooter;
